"use strict";'use strict';

var chunkA2IKZGN2_js = require('./chunk-A2IKZGN2.js');
require('./chunk-Q7Q3OVW2.js');



module.exports = chunkA2IKZGN2_js.ArrowRightCircle_default;
